/**
 * FR-050 U6 (AC-5.2) — the page part of the document title, per route.
 *
 * Values are Lingui msgids (English source). BrandTitleStrategy translates them
 * at runtime with `LinguiService.t()`; the extractor only walks templates, so
 * every value is also anchored in `route-title-anchors.component.html` and has a
 * Danish msgstr in `locales/da.po` (both pinned by route-titles.coverage.spec.ts).
 *
 * Only white-label (and fail-closed) tabs show the page part; standard mode keeps
 * today's "Tivedo — The growth desk" on every route (AC-5.5). The admin area has
 * no route titles: it is always standard (AC-3.6).
 */
export const ROUTE_TITLES = {
  // pre-login
  login: 'Log in',
  forgotPassword: 'Forgot password',
  resetPassword: 'Reset password',
  acceptInvitation: 'Accept invitation',
  forbidden: 'Access denied',
  register: 'Create an account',
  selectAccount: 'Select an account',
  noAccess: 'No access',
  /** FR-050 U8 (AC-6.5): the neutral and the branded not-found. */
  notFound: 'Page not found',
  /** FR-051 U7 (AC-4.2): an unknown or switched-off agency host. */
  notActive: 'This address is not active',
  /** FR-051 U7 fix F-A: the host context could not be read (fail closed). */
  unavailable: 'This address is temporarily unavailable',
  /** FR-075 REQ-6: the public privacy policy. */
  privacy: 'Privacy policy',
  // portal
  dashboard: 'Dashboard',
  activity: 'Activity',
  users: 'Users',
  profile: 'Profile',
  logos: 'Logos',
  socialMedia: 'Social media',
  displayMedia: 'Display media',
  facebookMedia: 'Facebook media',
  linkedinMedia: 'LinkedIn media',
  googleMedia: 'Google media',
  newCampaign: 'New campaign',
  allCampaigns: 'All campaigns',
  statistics: 'Statistics',
  campaign: 'Campaign',
  editCampaign: 'Edit campaign',
  bannerPreview: 'Banner preview',
  campaignStatistics: 'Campaign statistics',
  enhancedStatistics: 'Enhanced statistics',
  customers: 'Customers',
  addCustomer: 'Add customer',
  setUpCustomer: 'Set up customer',
  agencyCampaigns: 'Agency campaigns',
  orders: 'Orders',
  order: 'Order',
  performanceDashboard: 'Performance dashboard',
  reports: 'Reports',
  gdprRequests: 'GDPR data requests',
  branding: 'Branding',
  audiences: 'Audiences',
  subscriptions: 'Subscriptions',
  agencyStatistics: 'Agency statistics',
  facebook: 'Facebook',
  facebookImages: 'Facebook images',
  facebookVideos: 'Facebook videos',
  facebookPosts: 'Facebook posts',
  facebookAudiences: 'Facebook audiences',
  facebookAdSets: 'Facebook ad sets',
  google: 'Google',
  linkedin: 'LinkedIn',
  linkedinVideo: 'LinkedIn video',
  display: 'Display',
  displayAudience: 'Display audience',
} as const
